import { iContact } from "@sdk/crm/crm.models";
import {
  formatWAUsername,
  getWACloudNativeConnectionData,
  hasWACloudNativeOutboundIdentity,
} from "./get-wa-cloud-native-display-label";
import {
  getGroupContactDisplayLabel,
  isGroupContact,
} from "./is-wa-cloud-native-group";

export const GetContactIdentifier = (contact: iContact) => {
  if (!contact) {
    return "N/A";
  }

  if (isGroupContact(contact)) {
    return getGroupContactDisplayLabel({ contact });
  }

  if (contact.data.primaryEmail) {
    return contact.data.primaryEmail;
  }
  if (contact.data.primaryMobile) {
    return contact.data.primaryMobile;
  }

  const waConnectionData = getWACloudNativeConnectionData(contact);
  if (waConnectionData?.waUsername?.trim()) {
    return formatWAUsername(waConnectionData.waUsername);
  }
  if (hasWACloudNativeOutboundIdentity(contact)) {
    return "WhatsApp User";
  }

  if (contact.data) {
    return `No emails / mobile numbers`;
  }
};
